import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/muslim360logo.png'
const Navbar = () => {
  return ( 
    <nav className="navbar navbar-dark navbar-expand-lg">
      <div className="container-fluid ">
        <NavLink className="navbar-brand fs-4" to="/"><img width='105px' src={logo} alt=""/></NavLink>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-3 mb-2 mb-lg-0 fs-5">
            <li className="nav-item">
              <NavLink className="nav-link" aria-current="page" to="/">اوقات الصلاة</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="quran">القرآن</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="azkar">اذكار</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="qibla-compass">إتجاه القبلة</NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;